import { Link,useNavigate } from "react-router-dom";
import "./about.css"
//import "../../pages/app-wide.css";

const AboutContainer = ({}) => {

  return (
    <div className="about-continer-whole">
        <div className="about-container-left">
            <div className="about-container-left-inner-container">
                <p className="about-container-left-header">
                    Easy Holistic Stock Data
                </p>
                <p className="about-container-left-body">Stock Archives offers a complete historical stock data 
                    solution for small, mid, and large-cap companies — available 
                    via API, interactive dashboard, and Excel export. Ideal 
                    for analysts, quants, individual investors, and financial 
                    professionals seeking fast, flexible access to market data 
                    for deeper insights and smarter decision-making.</p>
                {/*<div className="about-container-signup-outer">
                <button className="about-container-signup-inner"><Link to= "/signup" className="about-container-signup-inner-link">Sign Up Now</Link></button>
                </div>*/}
            </div>
        </div>
        <div className="about-container-right">
            <svg
              width="500"
              height="625"
              viewBox="0 0 500 625"
              className="about-left-svg"
            >
                <rect
                    x="-150"
                    y="320"
                    width="150"
                    height="55"
                    rx="10"
                    ry="10"
                    fill="#296BE2"
                    fillOpacity="0.25"
                    transform="rotate(226 150 100)"
                />
                <rect
                    x="-150"
                    y="240"
                    width="200"
                    height="55"
                    rx="10"
                    ry="10"
                    fill="#296BE2"
                    transform="rotate(224 150 100)"
                />

                <rect
                    x="-190"
                    y="160"
                    width="200"
                    height="55"
                    rx="10"
                    ry="10"
                    fill="#2C9FB0"
                    fillOpacity="0.25"
                    transform="rotate(223 150 100)"
                />

                <rect
                    x="-120"
                    y="80"
                    width="245"
                    height="55"
                    rx="10"
                    ry="10"
                    fill="#FFFFFF"
                    transform="rotate(222 150 100)"
                />


                <rect
                    x="-210"
                    y="80"
                    width="75"
                    height="55"
                    rx="10"
                    ry="10"
                    fill="#FFFFFF"
                    transform="rotate(222 150 100)"
                />

                <rect
                    x="-110"
                    y="10"
                    width="200"
                    height="55"
                    rx="10"
                    ry="10"
                    fill="#2C9FB0"
                    fillOpacity="0.25"
                    transform="rotate(223 150 100)"
                />

                <rect
                    x="-170"
                    y="10"
                    width="50"
                    height="55"
                    rx="10"
                    ry="10"
                    fill="#296BE2"
                    fillOpacity="0.25"
                    transform="rotate(223 150 100)"
                />


                <rect
                    x="-220"
                    y="-65"
                    width="175"
                    height="55"
                    rx="10"
                    ry="10"
                    fill="#FFFFFF"
                    transform="rotate(223 150 100)"
                />

                
                <circle
                cx="560"
                cy="270"
                r="125"
                fill="#050B13"
                stroke="#FFFFFF"
                strokeWidth="1"
                />

                <circle
                cx="480"
                cy="445"
                r="175"
                fill="#050B13"
                stroke="#FFFFFF"
                strokeWidth="1"
                />

            </svg>
        </div>
                <div className="about-container-middle">
            <button className="about-container-signup-inner"><Link to= "/signup" className="about-container-signup-inner-link">Sign Up Now</Link></button>
        </div>
    </div>
  );
};

export default AboutContainer;